<template>
  <SACModal
    modalClass="partner-review-action-modal"
    :cardClass="`pram-${actionModalView}`"
    :show="showActionModal"
    :close="actionModalView !== 'verification-required' ? () => toggleActionModal(false) : null"
  >
    <template
      v-if="actionModalView === 'terms'"
      #content
    >
      <PartnerOrderCheckoutTerms />
    </template>
    <template
      v-else-if="actionModalView === 'update-shipping-address'"
      #content
    >
      <UpdateShippingAddress />
    </template>
    <template
      v-else-if="actionModalView === 'update-billing-address'"
      #content
    >
      <UpdateBillingAddress />
    </template>
    <template
      v-else-if="actionModalView === 'payment-methods'"
      #content
    >
      <AllPaymentMethods
        :corpId="order.corpId"
        :selectedPaymentMethod="selectedPaymentMethod"
        :toggleActionModal="toggleActionModal"
        :onSubmit="() => completeCheckout(true)"
        :changes="changePartnerReviewValues"
      />
    </template>
    <template
      v-else-if="actionModalView === 'new-payment-method'"
      #content
    >
      <NewPaymentMethod
        :corpId="order.corpId"
        :firstName="order.billingAddress.firstName"
        :lastName="order.billingAddress.lastName"
        :toEmail="order.toEmail"
        :changes="changePartnerReviewValues"
        :toggleActionModal="toggleActionModal"
        :onSubmit="completeCheckout"
        :showCreditCard="partnerSettings?.INVOICE_CREDIT_CARD_ENABLED"
      />
    </template>
    <template
      v-else-if="actionModalView === 'confirm-mandate'"
      #content
    >
      <ConfirmMandate
        :billingAddress="order.billingAddress"
        :setupIntent="setupIntent"
        :changes="changePartnerReviewValues"
        :toggleActionModal="toggleActionModal"
        :onSubmit="completeCheckout"
      />
    </template>
    <template
      v-else-if="actionModalView === 'verification-required'"
      #content
    >
      <VerificationRequired
        :toggleActionModal="toggleActionModal"
        :navigate="navigate"
        body="Once you completed the Micro-Deposit verification you will receive a order confirmation email and your order will be shipped!"
      />
    </template>
    <template
      v-else-if="actionModalView === 'credit-card'"
      #content
    >
      <CreditCard
        :close="() => toggleActionModal(true, 'new-payment-method')"
        :onSubmit="handleCreditCard"
      />
    </template>
  </SACModal>
</template>

<script>
import partnerReviewMixin from '@shared/mixins/partnerReviewMixin';

import SACModal from '@shared/components/sac/SACModal.vue';
import PartnerOrderCheckoutTerms from './modal/PartnerOrderCheckoutTerms.vue';
import UpdateShippingAddress from './modal/UpdateShippingAddress.vue';
import UpdateBillingAddress from './modal/UpdateBillingAddress.vue';
import AllPaymentMethods from '../shared/billingModal/AllPaymentMethods.vue';
import NewPaymentMethod from '../shared/billingModal/NewPaymentMethod.vue';
import CreditCard from '../shared/billingModal/CreditCard.vue';
import ConfirmMandate from '../shared/billingModal/ConfirmMandate.vue';
import VerificationRequired from '../shared/billingModal/VerificationRequired.vue';

export default {
  name: 'ActionModal',
  components: {
    SACModal,
    PartnerOrderCheckoutTerms,
    UpdateShippingAddress,
    UpdateBillingAddress,
    AllPaymentMethods,
    NewPaymentMethod,
    ConfirmMandate,
    VerificationRequired,
    CreditCard,
  },
  mixins: [partnerReviewMixin],
  methods: {
    async handleCreditCard(tokenId) {
      this.changePartnerReviewValues([{
        field: 'cardToken',
        value: tokenId,
      }, {
        field: 'paymentMethod',
        value: 'Credit Card',
      }]);
      await this.$store.dispatch('addPaymentMethod');
      await this.$store.dispatch('completePartnerOrderInvoice');
      this.$store.dispatch('getPartnerOrderReview', {
        orderNumber: this.order.orderNumber,
      });
      this.toggleActionModal(false);
    },
    async completeCheckout(existingPaymentMethod) {
      if (!existingPaymentMethod) {
        await this.$store.dispatch('addPaymentMethod');
      }
      await this.$store.dispatch('completePartnerOrderInvoice');
      this.$store.dispatch('getPartnerOrderReview', {
        orderNumber: this.order.orderNumber,
      });
    },
    navigate() {
      this.$router.replace(`/order/partner/${this.order.orderNumber}`);
    },
  },
};
</script>

<style lang="scss">

.partner-review-action-modal {
  .pram-terms {
    width: 600px;
    height: 650px;
  }
  .pram-new-payment-method {
    width: 400px;
    height: 500px;
  }
  .pram-payment-methods {
    width: 400px;
    height: 500px;
  }
  .pram-credit-card {
    width: 400px;
    height: 280px;
  }
  .pram-update-shipping-address, .pram-update-billing-address {
    width: 500px;
    height: 550px;
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .pram-confirm-mandate {
    width: 600px;
    height: 480px;
  }
  .pram-verification-required {
    width: 500px;
    height: 300px;
  }
  .ac-header-container {
    padding: 29px 24px 19px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between !important;
    border-bottom: 1px solid $NBLUE10;
    .ac-header {
      font-size: 1.25rem;
      font-weight: 500;
    }
    .ac-close-button {
      width: 32px;
      height: 32px;
      border-radius: 6px;
      background-color: $NBLUE10;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background-color: $NBLUE20;
      }
      .ac-close {
        width: 10px;
        height: 10px;
      }
    }
  }
  .ac-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    animation: fadeIn 0.5s ease;
    .ac-body-container {
      flex: 1;
      padding: 24px;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      .ac-body-header {
        font-size: 1.125rem;
        font-weight: 500;
        text-align: center;
      }
      .ac-body-terms {
          flex: 1;
          font-size: 1.125rem;
          color: $N100;
          text-align: justify;
      }
      .ac-info-container {
        &:not(:last-child) {
          margin-bottom: 8px;
        }
        .ac-header {
          width: 40%;
          font-size: 1.125rem;
          font-weight: 500;
          color: $N100;
        }
        .ac-body {
          flex: 1;
          font-size: 1.125rem;
          color: $N100;
          text-align: right;
        }
      }
      .ac-border-container {
        margin-bottom: 16px;
        padding-bottom: 16px;
        border-bottom: 1px solid $N10;
      }
      .ac-input-container {
        &:not(:last-child) {
          margin-bottom: 12px;
        }
        .ac-input-header {
          font-size: 1.125rem;
          font-weight: 500;
          margin-bottom: 4px;
          .ac-input-sub {
            font-size: 0.75rem;
            color: $N50;
          }
        }
        input {
          height: 48px;
          width: 100%;
          background-color: $NBLUE5;
          border: none;
          border-radius: 2px;
          padding: 0 10px;
        }
        textarea {
          width: 100%;
          height: 143px;
          padding: 8px 10px;
          border-radius: 2px;
          background-color: $NBLUE5;
          border: none;
          resize: none;
        }
        .ac-input-footer-container {
          display: flex;
          .ac-text-count {
            flex: 1;
            text-align: right;
            font-size: 0.75rem;
            font-weight: 500;
            color: $N60;
          }
        }
        .ac-input-error {
          color: $TOMATO100;
          font-size: 0.875rem;
        }
      }
      .ac-status {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: $NBLUE5;
        padding: 20px;
        border-radius: 6px;
        font-size: 16px;
        margin-bottom: 8px;
        font-weight: 500;
      }
      .ac-note-container {
        margin-bottom: 32px;
        .ac-note {
          font-weight: 500;
          color: $N60;
        }
        .ac-info {
          font-weight: 500;
        }
      }
      .ac-p-text {
        display: grid;
        justify-content: center;
      }
    }
  }
  .ac-button-container {
    display: flex;
    margin-top: 16px;
    align-items: flex-end;
    justify-content: center;
    flex: 1;
    button {
      width: 180px;
      height: 45px;
      border-radius: 8px;
      color: $WHITE;
      font-size: 1rem;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      .wheel {
        width: 25px;
      }
      &.cancel-btn {
        background-color: $N90;
      }
      &.delete-btn {
        background-color: $TOMATO100;
        margin-left: 12px;
      }
      &.submit-btn {
        background-color: $NBLUE100;
        margin-left: 12px;
      }
    }
  }
  .ac-footer-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 16px 24px;
    border-top: 1px solid $NBLUE10;
    .ac-back-container {
      flex: 1;
      justify-content: flex-start;
      .ac-back-button {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 17px;
        width: 177px;
        height: 40px;
        border-radius: 6px;
        background-color: $NBLUE10;
        &:hover {
          background-color: $NBLUE20;
        }
        .back-icon {
          width: 6px;
        }
        .button-text {
          font-weight: 600;
        }
      }
    }
    .ac-form-button {
      width: 120px;
      height: 40px;
      border-radius: 6px;
      background-color: $NBLUE10;
      font-weight: 600;
      &:hover {
        background-color: $NBLUE20;
      }
      &:not(:first-child) {
        margin-left: 11px;
        background-color: $NBLUE100;
        color: $WHITE;
        &:hover {
          background-color: $NBLUE90;
        }
      }
    }
    .ac-form-cancel-button {
      width: 120px;
      height: 40px;
      border-radius: 6px;
      background-color: $NBLUE10;
      font-weight: 600;
      &:hover {
        background-color: $NBLUE20;
      }
    }
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
